import { Button, Link, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@heroui/react";
import { useEffect, useState } from "react";
import ModalManager from "./Modal-Manager";

interface IModalState {
    show: boolean;
    size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
    message: string | React.ReactNode | null;
    messageDetails?: string | null;
    header?: string | React.ReactNode | null;
    showActionButton?: boolean;
    actionButtonText?: string;
    showCancelButton?: boolean;
    cancelButtonText?: string;
    hideHeaderCloseIcon?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
}

const SharedModal: React.FC = () => {

    const [modalState, setModalState] = useState<IModalState>({
        show: false,
        size: 'xs',
        message: '',
        messageDetails: '',
        header: '',
        showActionButton: true,
        actionButtonText: 'Action',
        showCancelButton: true,
        cancelButtonText: 'Close',
        hideHeaderCloseIcon: false,
    });

    const [showDetailedMessage, setShowDetailedMessage] = useState(false);


    useEffect(() => {
        // Subscribe to modal updates
        ModalManager.subscribe((options: unknown) => {
            setModalState(options as IModalState);
        });

        // Cleanup on component unmount
        return () => {
            ModalManager.unsubscribe(() => setModalState);
        };
    }, []);

    if (!modalState.show) return null;

    const handleConfirm = () => {
        modalState.onConfirm?.();
        ModalManager.close(); // Close the modal after confirmation
    };

    const handleCancel = () => {
        modalState.onCancel?.();
        ModalManager.close(); // Close the modal on cancel
    };

    return <Modal
        classNames={{
            closeButton: 'rounded-sm',
        }} size={modalState.size} aria-labelledby="confirmation-modal" hideCloseButton={modalState.hideHeaderCloseIcon} isDismissable={false} backdrop="opaque" className="rounded-sm" isOpen={modalState.show} onClose={() => ModalManager.close()}>
        <ModalContent>

            <ModalHeader className="flex flex-col gap-1">{modalState.header}</ModalHeader>
            <ModalBody>
                {modalState.message}
                {modalState.messageDetails && <div className="grid grid-cols-2 gap-4 col-start-1 col-end-3">
                    <div className="col-start-1 col-end-3">
                        <Link as="button"
                            onPress={() => {
                                setShowDetailedMessage(!showDetailedMessage);
                            }}
                        >
                            Show Detail
                        </Link>
                    </div>
                    <div className="col-start-1 col-end-3" hidden={!showDetailedMessage}>
                        <Textarea value={modalState.messageDetails}></Textarea>
                    </div>
                </div>
                }
            </ModalBody>
            <ModalFooter>
                {modalState.showCancelButton && <Button className="rounded-sm" size="sm" color="danger" onPress={handleCancel}>
                    {modalState.cancelButtonText}
                </Button>}
                {modalState.showActionButton && <Button className="rounded-sm" size="sm" color="primary" onPress={handleConfirm}>
                    {modalState.actionButtonText}
                </Button>}
            </ModalFooter>

        </ModalContent>
    </Modal>;
}

export default SharedModal;